import { ApiService } from "Services/ApiService";
import { ResultsDTO } from "Types/ResultsDTO";

export interface ActiveLanguage {
  id: number;
  language: string;
  isActive: string;
}

export const activeLanguageApiSlice = ApiService.injectEndpoints({
  endpoints: (builder) => ({
    getAllActiveLanguages: builder.query<ActiveLanguage[], void>({
      query: () => ({
        url: "language/active-language",
        method: "GET",
      }),
      transformResponse: (res: ResultsDTO<ActiveLanguage[]>) => res.results ?? [],
      providesTags: [{ type: "Language", id: "ACTIVE_LIST" }],
    }),
  }),
});

export const { useGetAllActiveLanguagesQuery } = activeLanguageApiSlice;
